// src/pages/About.js
import React from 'react';
import "../components/Card2.css";  // Import the CSS file for Card2

const About = (props) => {
  return (
    <div className="card">
      {/* Render the icon */}
      <div className="card-icon">{props.icon}</div>
      
      <h2>{props.name}</h2>
      <p>{props.para}</p>
    </div>
  );
};

export default About;
